import { Download } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const Metric = ({ label, value, testId }) => (
  <div className="rounded-2xl bg-[#12141F] border border-white/[0.07] p-6" data-testid={testId}>
    <div className="text-xs uppercase tracking-wider text-slate-500">{label}</div>
    <div className="font-display text-4xl font-extrabold mt-3">{value}</div>
  </div>
);

export const MetricsGrid = ({ stats }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <Metric label="Idee generate" value={stats.ideas_generated} testId="admin-metric-ideas" />
    <Metric label="Idee verificate" value={stats.validations} testId="admin-metric-validations" />
    <Metric label="Piani d'azione" value={stats.plans} testId="admin-metric-plans" />
    <Metric label="Iscritti lista d'attesa" value={stats.waitlist.length} testId="admin-metric-waitlist" />
    <Metric label="Abbonati Pro attivi" value={stats.pro_subscribers} testId="admin-metric-pro" />
    <Metric label="Analisi concorrenti" value={stats.competitor_reports} testId="admin-metric-competitors" />
    <Metric label="Idee condivise" value={stats.shared_ideas} testId="admin-metric-shared" />
    <Metric label="Iscritti avvisi giornalieri" value={stats.push_subscribers} testId="admin-metric-push" />
  </div>
);

export const CategoriesChart = ({ categories, avgScore }) => (
  <div className="lg:col-span-7 rounded-3xl bg-[#12141F] border border-white/[0.07] p-6" data-testid="admin-categories-chart">
    <div className="flex justify-between">
      <div className="font-display font-semibold">Categorie più richieste</div>
      <div className="text-sm text-slate-400">Punteggio medio: <span className="text-amber-300 font-mono" data-testid="admin-avg-score">{avgScore}</span></div>
    </div>
    <div className="h-64 mt-6">
      {categories.length ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={categories}>
            <XAxis dataKey="name" stroke="#64748b" fontSize={12} tickLine={false} axisLine={false} />
            <YAxis stroke="#64748b" fontSize={12} allowDecimals={false} tickLine={false} axisLine={false} />
            <Tooltip cursor={{ fill: "rgba(255,255,255,0.03)" }} contentStyle={{ background: "#0d0f17", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12 }} />
            <Bar dataKey="count" name="Idee" fill="#F59E0B" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : <p className="text-sm text-slate-500">Ancora nessun dato.</p>}
    </div>
  </div>
);

const exportCsv = (rows) => {
  const csv = "email,piano,data\n" + rows.map((r) => `${r.email},${r.plan},${r.created_at}`).join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  a.download = "lista-attesa-ideaforge.csv";
  a.click();
};

export const WaitlistPanel = ({ waitlist }) => (
  <div className="lg:col-span-5 rounded-3xl bg-[#12141F] border border-white/[0.07] p-6">
    <div className="flex items-center justify-between">
      <div className="font-display font-semibold">Lista d'attesa</div>
      <button onClick={() => exportCsv(waitlist)} data-testid="btn-export-csv" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-amber-300 transition-colors"><Download className="w-4 h-4" /> CSV</button>
    </div>
    <div className="mt-4 max-h-64 overflow-y-auto" data-testid="admin-waitlist-table">
      {waitlist.length === 0 ? <p className="text-sm text-slate-500">Nessun iscritto per ora.</p> : waitlist.map((w) => (
        <div key={w.email} className="flex justify-between gap-3 py-2.5 border-b border-white/5 text-sm">
          <span className="text-slate-200 truncate">{w.email}</span>
          <span className="text-amber-300 uppercase text-xs font-semibold shrink-0">{w.plan}</span>
        </div>
      ))}
    </div>
  </div>
);
